import { atomWithStorage } from 'jotai/utils';

export const collapsedAtom = atomWithStorage('layout-collapsed', false);

export const openKeysAtom = atomWithStorage<string[]>('layout-openKeysAtom', []);

export const pageTabsAtom = atomWithStorage<
  {
    title: string;
    url: string;
  }[]
>('page-tabs', []);
